declare global {
  export interface Window {
    dataLayerArray?: any[];
    ASH_CHECKLIST_isChecklistReferral?: boolean;
    ASH_CHECKLIST_settingsPromise?: Promise<Settings>;
    ASH_CHECKLIST_csrfPromise?: Promise<any>;
  }
}

export type Stage =
  | "local"
  | "alpha"
  | "beta"
  | "gamma"
  | "preprod"
  | "prod"
  | "alpha-mx"
  | "beta-mx"
  | "gamma-mx"
  | "preprod-mx"
  | "prod-mx";

export interface Settings {
  stage: Stage;
  apiEndpoint?: string;
}

const DEFAULT_SETTINGS: Settings = {
  stage: "prod",
};

export const getSettings = async (): Promise<Settings> => {
  try {
    window.ASH_CHECKLIST_settingsPromise =
      window.ASH_CHECKLIST_settingsPromise ||
      fetch("/settings.json").then((result) => result.json());
    return await window.ASH_CHECKLIST_settingsPromise;
  } catch (e) {
    console.error(e);
    return DEFAULT_SETTINGS;
  }
};

export const US_STAGES: Array<Stage> = [
  "local",
  "alpha",
  "beta",
  "gamma",
  "preprod",
  "prod",
];
export const MX_STAGES: Array<Stage> = [
  //"local",
  "alpha-mx",
  "beta-mx",
  "gamma-mx",
  "preprod-mx",
  "prod-mx",
];
